$(window).on("load", function() {

});